import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UserLoginComponent } from './pages/login/user-login/user-login.component';
import { BodyComponent } from './pagecomponents/body/body.component';
import { MenuComponent } from './pages/menu/menu.component';
import { UserChangePasswordComponent } from './pages/login/user-change-password/user-change-password.component';
import { NavbarComponent } from './pages/menu/navbar/navbar.component';
import { DropdownMenuComponent } from './pages/menu/dropdown-menu/dropdown-menu.component';
import { ActivePageComponent } from './pages/menu/active-page/active-page.component';
import { HomeComponent } from './pages/home/home.component';
import { GestioneUtentiComponent } from './pages/impostazioni/gestione-utenti/gestione-utenti.component';
import { LoadingPageComponent } from './pagecomponents/loading-page/loading-page.component';
import { SavingPageComponent } from './pagecomponents/saving-page/saving-page.component';
import { SearchPageComponent } from './pagecomponents/search-page/search-page.component';
import { PageHeaderComponent } from './pagecomponents/page-header/page-header.component';
import { DevicesListComponent } from './pages/devices/devices-list/devices-list.component';
import { DeviceDetailDialogComponent } from './pagecomponents/devices/device-detail-dialog/device-detail-dialog.component';
import { OperationsLogComponent } from './pages/devices/operations-log/operations-log.component';
import { DevicesManagementComponent } from './pages/devices/devices-management/devices-management.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DeviceMapDialogComponent } from './pagecomponents/devices/device-map-dialog/device-map-dialog.component';
import { ForgotPasswordComponent } from './pages/login/forgot-password/forgot-password.component';
import { DeleteAccountComponent } from './pages/login/delete-account/delete-account.component';
import { UnauthenticatedMenuComponent } from './pages/menu/unauthenticated-menu/unauthenticated-menu.component';


@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    BodyComponent,
    UserLoginComponent,
    PageHeaderComponent,
    UserChangePasswordComponent,
    GestioneUtentiComponent,
    LoadingPageComponent,
    SavingPageComponent,
    SearchPageComponent,
    HomeComponent,
    NavbarComponent,
    DropdownMenuComponent,
    ActivePageComponent,
    DevicesListComponent,
    DeviceDetailDialogComponent,
    OperationsLogComponent,
    DevicesManagementComponent,
    DeviceMapDialogComponent,
    ForgotPasswordComponent,
    DeleteAccountComponent,
    UnauthenticatedMenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    MatToolbarModule,
    MatDialogModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory
      }
    })
  ],
  providers: [
    MessageService
    // ,
    // BizService,
    // AccessPermissionsService,
    // MenuService
    , {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: './assets/languages/',
        suffix: '.json'
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'no_skins',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/no_skins_icon.svg')
    );

    iconRegistry.addSvgIcon(
      'column',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/column_icon.svg')
    );
  }
}

export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}
